import styled from "styled-components";

export const breakpoints = {
  sm: "600px",
  md: "960px",
  lg: "1280px",
};

export const ContainerStyle = styled.div`
  width: 95%;
  max-width: 1800px;
  height: 100%;
  min-height: 60px;
  text-align: center;
  position: relative;
  margin: 0 auto;
  background-color: white;

  @media print {
      display: none;
  }

  button {
    display: none;
  }

  @media screen and (max-width: ${breakpoints.md}) {\
    top: 0;
    width: 100%;
    height: 60px;
    position: fixed;
    z-index: 2000;
    button {
      margin-left: 2px;
      height: auto;
      cursor: pointer;
      display: inline-block;
      background: none;
      border: none;
      transition: all 0.2s linear;
      padding: 10px 35px 16px 0;
      position: absolute;
      top: 17px;
      left: 0px;
      z-index: 1000;

      &.active {
        transform: rotate(540deg);
        span {
          background: none !important;
          :before {
            transform: rotate(45deg);
            top: 0;
          }
          :after {
            transform: rotate(-45deg);
            top: 0;
          }
        }
      }

      span {
        height: 5px;
        width: 35px;
        content: "";
        display: block;
        cursor: pointer;
        background: #000;
        position: absolute;
        border-radius: 1px;
        transition: all 100ms linear;

        &:before {
          top: -10px;
          height: 5px;
          width: 35px;
          content: "";
          display: block;
          cursor: pointer;
          background: #000;
          position: absolute;
          border-radius: 1px;
          transition: all 100ms linear;
        }

        &:after {
          bottom: -10px;
          height: 5px;
          width: 35px;
          content: "";
          display: block;
          cursor: pointer;
          background: #000;
          position: absolute;
          border-radius: 1px;
          transition: all 100ms linear;
        }
      }
    }
  }
`;

export const LogoStyle = styled.img`
  width: 100px;
  max-width: 100px;
`;

export const DelTacoLogo = styled.h1`
  position: absolute;
  top: 0;
  margin: 0;
  z-index: 100;

  @media screen and (max-width: ${breakpoints.md}) {
    display: inline-block;
    position: relative;
    height: 60px;
  }
`;

export const MenuNav = styled.nav`
  position: relative;
  min-height: 60px;
  padding-right: 80px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  @media screen and (max-width: ${breakpoints.md}) {
    padding-right: 0;
    flex-direction: column-reverse;

    &.active{
      width: 100%;
      background: white;
      z-index: 1000;
      border-bottom: 1px solid black;
      border-top: 1px solid black;
    }
    
    
    &:not(.active) {
      min-height: 0px;
      height: 0;
    }
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    width: 100%;
  }

  a {
    text-decoration: none;
  }

  li {
    display: inline-block;
  }
`;

export const GlobalNav = styled.ul`
  visibility: visible;
  opacity: 1;
  height: auto;
  display: inline-block;
  width: 100%;
  text-align: right;

  a {
    cursor: pointer;
    display: inline-block;
    text-align: center;
    text-transform: uppercase;
    color: #000;
    margin-top: -10px;
    transition: margin-top 0.3s ease;
    font-family: "Nunito Sans", "Nunito-Sans-Fallback", sans-serif;
    font-weight: 900;
    font-size: 1.2em;
    line-height: 1;
  }

  li {
    display: inline-block;
    vertical-align: top;
    padding: 0 32px;
  }

  @media screen and (max-width: ${breakpoints.md}) {
    
      visibility: hidden;
    

    &.active {
      height: auto;
      visibility: visible;
      opacity: 1;
      transition: 0.3s ease;
      padding: 0px 0 0 0;
      width: 100%;
      max-width: 1000px;
      z-index: 1000;
      margin: 0 auto;

      li {
        display: list-item;
        height: auto;
        padding-top: 10px;
        padding-bottom: 10px;
      }

      a {
        width: 100%;
        padding: 0 15px;
        height: 40px;
      }
    }
  }
`;

export const GlobalSubNav = styled.ul`
  display: block;
  text-align: right;

  li {
    display: inline-block;
    padding: 0 10px;
    &:nth-child(2) :before {
      content: "|";
      padding-right: 5px;
    }
    &:nth-child(3) :before {
      content: "|";
      padding-right: 5px;
    }
  }

  a {
    font-size: 0.8em;
    line-height: 5px !important;
    text-decoration: none;
    display: block;
    padding: 10px 0;
    color: #dc4547 !important;
    height: auto !important;
  }

  @media screen and (max-width: ${breakpoints.md}) {
    
    visibility: hidden;
    

    &.active {
      height: auto;
      visibility: visible;
      opacity: 1;
      transition: 0.3s ease;
      padding: 0px 0 0 0;
      width: 100%;
      max-width: 1000px;
      z-index: 1000;
      margin: 0 auto;
      text-align: center;

      li {
        display: list-item;
        height: auto;
        padding-top: 15px;
        padding-bottom: 15px;
        &:nth-child(2) :before {
          content: none;
          padding-right: 0;
        }
        &:nth-child(3) :before {
          content: none;
          padding-right: 0;
        }
      }

      a {
        width: 100%;
        padding: 0 15px;
        height: 40px;
      }
    }
  }
`;

export const IconWrapper = styled.div`
  display: none;
  @media screen and (max-width: ${breakpoints.md}) {
    display: flex;
    position: absolute;
    top: 1em;
    right: 0.25em;

    a {
      padding-right: 10px;
      padding-left: 10px;
    }
  }
`;

export const OrderNav = styled.ul`
  position: absolute;
  top: 0;
  right: 0;
  max-width: 80px;
  height: 60px;
  text-align: center;

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    background-color: #dc4547;
    color: white;
    font-size: 12px;
    font-weight: 800;
    text-transform: uppercase;
  }

  @media screen and (max-width: ${breakpoints.md}) {
    left: 40px;
    top: -60px;

    &.active {
      top:-61px;
    }
    
  }
`;

export const ChildrenContainerStyle = styled.div`
  @media screen and (max-width: ${breakpoints.md}) {
    margin-top: 60px
  }
`
